import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { courses as coursesApi } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Play, Sparkles, ShoppingBag } from "lucide-react";
import ReferralPanel from "@/components/ReferralPanel";

const Dashboard = () => {
  const { user, loading } = useAuth();
  const [my, setMy] = useState([]);
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    if (user) {
      coursesApi
        .mine()
        .then(setMy)
        .finally(() => setFetching(false));
    }
  }, [user]);

  if (loading) return null;
  if (!user) return <Navigate to="/" replace />;

  return (
    <main data-testid="dashboard-page" className="bg-zinc-50 min-h-[80vh]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="flex items-center gap-3 mb-2">
          <Sparkles className="w-4 h-4 text-[#4F46E5]" />
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#4F46E5]">
            Mi área de estudiante
          </p>
        </div>
        <h1
          data-testid="dashboard-greeting"
          className="font-display font-black text-4xl md:text-5xl tracking-tighter mb-12"
        >
          Hola, {user.name.split(" ")[0]}.
        </h1>

        <h2 className="font-display font-bold text-2xl mb-6">Mis cursos</h2>

        {fetching ? (
          <div className="text-zinc-500">Cargando tus cursos...</div>
        ) : my.length === 0 ? (
          <div
            data-testid="dashboard-empty"
            className="bg-white border border-zinc-200 p-12 text-center"
          >
            <ShoppingBag className="w-10 h-10 mx-auto text-zinc-400 mb-4" />
            <h3 className="font-display font-bold text-xl mb-2">Aún no tienes cursos</h3>
            <p className="text-zinc-600 mb-6 max-w-md mx-auto">
              Explora el catálogo y empieza a aprender hoy mismo.
            </p>
            <Link
              to="/"
              className="inline-flex items-center bg-[#4F46E5] hover:bg-[#4338CA] text-white px-6 py-3 font-semibold"
            >
              Ver catálogo
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {my.map((c) => (
              <Link
                key={c.id}
                to={`/curso/${c.id}`}
                data-testid={`my-course-${c.id}`}
                className="bg-white border border-zinc-200 hover:border-zinc-900 transition group"
              >
                <div className="aspect-[4/3] overflow-hidden bg-zinc-100 relative">
                  <img src={c.thumbnail} alt={c.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-zinc-900/50 opacity-0 group-hover:opacity-100 transition flex items-center justify-center">
                    <Play className="w-12 h-12 text-white" />
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="font-display font-bold text-lg mb-1">{c.title}</h3>
                  <p className="text-xs text-zinc-500">
                    {c.modules?.length || 0} módulos · {c.duration}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        )}

        <ReferralPanel />
      </div>
    </main>
  );
};

export default Dashboard;
